<template>
  <Modal
    fullscreen
    :closable="false"
    :mask-closable="false"
    footer-hide
    class="hand2_con"
    v-model="showCamera"
    @on-cancel="cancel"
  >
    <div class="h-body" :class="{ hide: !isPic }">
      <div class="h-left">
        <div class="h-title">
          <i class="iconfont icon-shouzhang"></i>
          <span class="label">手相解读</span>
        </div>
        <div class="h-menu">
          <div
            @click="selectMenuItem(item, index)"
            class="h-menu-item"
            :class="{ active: item.active }"
            v-for="(item, index) in infoList3"
            :key="index"
          >
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div class="h-button-group" v-if="showZoomBtn && showPalmistry">
          <div class="h-button-title">手相识别</div>
          <div class="h-button-list">
            <CheckboxGroup v-model="checkBox" @on-change="checkBoxChange">
              <Checkbox
                :label="item.value"
                v-for="(item, index) in checkBoxList"
                :key="index"
              >
                <i class="icon1 iconfont icon-yanjing"></i>
                <i class="icon2 iconfont icon-yanjing1"></i>
                <span>{{ item.label }}</span>
              </Checkbox>
            </CheckboxGroup>
          </div>
        </div>
      </div>
      <div class="h-center">
        <div class="h-center-body">
          <div class="h-right-hender">
            <div class="userinfo2">
              <i class="icon iconfont icon-touxiang1"></i>
              <span class="name">{{ cameraInfo3.info.patientName }}</span>
              <span>{{ cameraInfo3.info.sex }}</span>
              <span>{{ cameraInfo3.info.patientAge }}岁</span>
              <span>手机号:{{ cameraInfo3.info.cellphoneNo }}</span>
            </div>
          </div>
          <div class="h-center-content">
            <infoList :list="infoListCenter" @clickItem="clickItem" />
          </div>
        </div>
      </div>
      <div class="h-right">
        <div class="h-right-body">
          <div class="h-right-hender">
            <div></div>
            <div class="show-palmistry-btn">
              <span class="btn1">
                <span @click="showMore">{{
                  allMore ? "全部收起" : "全部更多"
                }}</span>
                <i v-if="allMore" class="xszy-icon icon-up"></i>
                <i v-else class="xszy-icon icon-down"></i>
              </span>
              显示手相图片<i-switch v-model="showPalmistry" />
            </div>
          </div>
          <div class="desc">蓝色<i>稀有</i>词条为罕见词条</div>
          <div class="h-right-content">
            <infoList
              v-if="!showPalmistry"
              :list="infoListRight"
              @clickItem="clickItem"
            />
            <handCanvas
              :class="{ 'hide-palmistry': !showPalmistry }"
              :systemVersionTooLow="systemVersionTooLow"
            />
          </div>
          <div v-if="showPalmistry" class="footer">
            <template v-if="isPic">
              <template v-if="showZoomBtn && !systemVersionTooLow">
                <Tooltip content="显示手相分区" placement="top">
                  <div class="icon" @click="showNiceFun">
                    <i v-if="showNice" class="iconfont icon-yanjing"></i>
                    <i v-else class="iconfont icon-yanjing1"></i>
                  </div>
                </Tooltip>
                <Tooltip content="放大" placement="top">
                  <div class="icon" @click="zoom(1)">
                    <i class="iconfont icon-zoomin"></i>
                  </div>
                </Tooltip>
                <Tooltip content="缩小" placement="top">
                  <div class="icon" @click="zoom(0)">
                    <i class="iconfont icon-zoomout"></i>
                  </div>
                </Tooltip>
              </template>
              <Tooltip content="拍照" placement="top">
                <div class="icon" @click="photograph">
                  <i class="iconfont icon-xiangji3"></i>
                </div>
              </Tooltip>
            </template>
            <Tooltip content="上传手相图片" placement="top" v-if="showBtn">
              <div class="icon" @click="uploadPic">
                <Icon type="md-cloud-upload" />
              </div>
            </Tooltip>
            <Tooltip content="历史图片" placement="top">
              <div class="icon" @click="poupoPic">
                <i class="iconfont icon-tupian"></i>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
    <Icon @click="closeFun" class="modal_close" type="md-close-circle" />
    <div class="btn_g" v-if="!isPic">
      <div
        class="btn pics"
        @click="poupoPic"
        :style="{ marginLeft: (height * proportion) / 2 + 30 + 'px' }"
      >
        <Tooltip content="解读其他手相照片" placement="bottom">
          <i class="iconfont icon-tupian"></i>
        </Tooltip>
      </div>
      <div
        v-if="showBtn"
        class="btn pics"
        @click="uploadPic"
        :style="{ marginLeft: (height * proportion) / 2 + 100 + 'px' }"
      >
        <Tooltip content="上传手相图片" placement="bottom">
          <Icon type="md-cloud-upload" />
        </Tooltip>
      </div>
    </div>

    <div v-show="!isPic" class="camera_group" :style="style">
      <div class="camera_group_body">
        <camera32
          :width="height * proportion"
          :height="height"
          ref="camera3"
          @showPic="showPic"
          :showWin="!isPic"
          :patientInfo="cameraInfo3.info"
        />
        <div class="jb_group2">
          <div class="jb_top"></div>
          <div class="jb_right"></div>
          <div class="jb_bottom"></div>
          <div class="jb_left"></div>
        </div>
      </div>
    </div>
    <div v-if="showPicList" class="mask" @click="hideMask"></div>
    <div @click.stop class="u_pics_k" :class="{ show: showPicList }">
      <div ref="images" class="u_pics">
        <template v-if="oldPics.length">
          <div
            class="u_pic"
            v-for="(item, index) in oldPics"
            :key="index + '_a'"
          >
            <div class="img_k" @click="clickPic(item)">
              <img v-if="/^data:/.test(item.picUrl)" :src="item.picUrl" />
              <img v-else-if="/^http/.test(item.picUrl)" :src="item.picUrl" />
              <img v-else :src="cloudPic + '/hand/' + item.picUrl" />
            </div>
            <div
              v-if="isToday(item.crDt)"
              @click="delPic(item, index, true)"
              class="del_btn"
            >
              <Icon type="ios-close-circle" />
            </div>
            <i class="date">{{ item.crDt }}</i>
          </div>

          <div id="photograph-btn" class="u_pic">
            <div class="img_k" @click="photograph">
              <Icon type="md-camera" />
              <div class="tip">拍照</div>
            </div>
            <i class="date text-white">.</i>
          </div>

          <div id="photograph-btn2" class="u_pic" v-if="showBtn">
            <div class="img_k" @click="uploadPic">
              <Icon type="md-cloud-upload" />
              <div class="tip">上传</div>
            </div>
            <i class="date text-white">.</i>
          </div>
        </template>
        <empty v-else />
      </div>
    </div>
    <Modal
      title="手相拍摄规范"
      width="700"
      footer-hide
      class="handHelp"
      v-model="showHelp"
    >
      <div class="left">
        <img src="@/assets/images/hand/tl.jpg" alt />
      </div>
      <div class="right">
        <div class="item_title">参照左图：</div>
        <div>1、手指微张不并拢，大拇指打开</div>
        <div>2、不佩戴任何物件（例如手表、戒指）</div>
        <div>3、使用慈脉云诊专用手相仪拍照</div>
      </div>
    </Modal>

    <Spin v-if="isLogin && !showPalmistry" class="openApp_loader" fix>
      <div class="u_loader_k">
        <div class="u_loader"></div>
        <img src="@/assets/images/logo.png" alt />
      </div>
      <div>手相识别中</div>
    </Spin>
  </Modal>
</template>

<script>
import infoList from "./infoList.vue";
import handCanvas from "./handCanvas.vue";
import { hasAuth } from "@/utils/uEdition.js";
import camera32 from "./camera3_2.vue";
import Hander from "@/assets/js/Hander2.js";
import { Scene } from "spritejs";
import { mapGetters } from "vuex";
// import omljosn from "@/assets/js/OML2CIMAi7.json";
export default {
  components: {
    camera32,
    handCanvas,
    infoList,
  },
  computed: {
    ...mapGetters([
      "cameraInfo3",
      "handData",
      "handRefresh",
      "palmDeviceSize",
      "userInfo",
      "dicts",
    ]),
    handRareData() {
      return this.dicts.HAND_RARE_DATA || [];
    },
    style() {
      let width = this.height * this.proportion;
      let height = this.height;

      return {
        width: width + 12 + "px",
        height: height + 12 + "px",
        marginTop: -height / 2 + "px",
        marginLeft: -width / 2 + "px",
      };
    },
    infoList3() {
      return this.infoList2.some((i) => i.value) ? this.infoList2 : [];
    },
    infoListCenter() {
      return this.showPalmistry ? this.infoList3 : this.infoList3.slice(0, 1);
    },
    infoListRight() {
      return this.showPalmistry ? [] : this.infoList3.slice(1);
    },
    showBtn() {
      return hasAuth("YZ-13");
    },
  },
  watch: {
    cameraInfo3(newValue, oldValue) {
      this.showCamera = this.cameraInfo3.showWin;
      if (newValue.showWin) {
        this.isInfo = false;
        this.isPic = true;
        this.isOpen = false;
        this.getData();
      }
    },
    handData() {
      this.handDataChange();
    },
    handRefresh() {
      this.photograph();
      this.$Message.error(
        "手相识别失败，请重新拍照。请确保手掌掌心朝上平铺于手诊仪底部，五指指尖在拍摄范围内后进行拍照。"
      );
    },
  },
  data() {
    return {
      allMore: false,
      showPalmistry: false,
      xh: [
        "①",
        "②",
        "③",
        "④",
        "⑤",
        "⑥",
        "⑦",
        "⑧",
        "⑨",
        "⑩",
        "⑪",
        "⑫",
        "⑬",
        "⑭",
        "⑮",
        "⑯",
        "⑰",
        "⑱",
        "⑲",
        "⑳",
        "㉑",
        "㉒",
        "㉓",
        "㉔",
        "㉕",
        "㉖",
        "㉗",
        "㉘",
        "㉙",
        "㉚",
        "㉛",
        "㉜",
        "㉝",
        "㉞",
        "㉟",
        "㊱",
        "㊲",
        "㊳",
        "㊴",
        "㊵",
        "㊶",
        "㊷",
        "㊸",
        "㊹",
        "㊺",
        "㊻",
        "㊼",
        "㊽",
        "㊾",
        "㊿",
      ],
      height: 700,
      proportion: 0.75,

      systemVersionTooLow: false, //操作系统版本是否过低
      picUrl: "",
      djs: null,
      showNice: false,
      infoList: [],

      base64: "",
      imageHeight: "",
      imageWidth: "",

      showZoomBtn: false,
      showHelp: false,
      isInfo: false,
      showCamera: false,
      showInfo: true,
      isOpen: false,
      scene: null,
      layer: null,
      isPic: true, //有图
      hander: null,
      showPicList: false,
      oldPics: [],
      isLogin: false,

      checkBox: [],
      checkBoxList: [
        {
          value: 1,
          label: "九丘一平原",
        },
        {
          value: 2,
          label: "三大主线",
        },
        {
          value: 3,
          label: "纹路",
        },
        {
          value: 4,
          label: "斑点",
        },
        {
          value: 5,
          label: "青筋",
        },
        {
          value: 6,
          label: "指节纹",
        },
      ],
      unscrambleList: {},
      colorList: [],
      // 解读来源 1健康 2 婚姻 3 家庭 4 财富 5 事业 6 其他
      infoList2: [
        {
          icon: "icon-xunhuan",
          title: "健康",
          value: [],
          id: 1,
          active: true,
          isShow: false,
        },
        {
          icon: "icon-hunyinzhuangkuangbiangeng",
          title: "婚姻",
          value: [],
          id: 2,
          active: false,
          isShow: false,
        },
        {
          icon: "icon-home1",
          title: "家庭",
          value: [],
          id: 3,
          active: false,
          isShow: false,
        },
        {
          icon: "icon-qianbao",
          title: "财富",
          value: [],
          id: 4,
          active: false,
          isShow: false,
        },
        {
          icon: "icon-renshiyewu",
          title: "事业",
          value: [],
          id: 5,
          active: false,
          isShow: false,
        },
        {
          icon: "icon-qita",
          title: "其他",
          value: [],
          id: 6,
          active: false,
          isShow: false,
        },
      ],
    };
  },
  methods: {
    showMore() {
      this.allMore = !this.allMore;
      this.infoList3.forEach((item) => {
        item.value.forEach((i) => {
          i.onShowMore && i.onShowMore(this.allMore);
        });
      });
    },
    selectMenuItem(item, index) {
      this.clickItem(item);
      // 滚动到指定位置
      let node = this.$el.querySelector(".h-center .infoList-" + index);
      if (node) {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      let node2 = this.$el.querySelector(".h-right .infoList-" + (index - 1));
      if (node2) {
        node2.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    clickItem(item) {
      this.infoList2.forEach((i) => {
        i.active = item == i ? true : false;
      });
    },

    checkBoxChange(ids) {
      this.hander.clickBtn(ids);
    },
    hideMask() {
      this.showPicList = false;
      if (!this.layer) {
        this.photograph();
      }
    },
    handDataChange() {
      if (!this.isPic) return;
      if (this.handData.nineHillsPlains.length) {
        this.init();
        this.isPic = true;
        clearTimeout(this.djs);
        this.djs = setTimeout(() => {
          this.isInfo = true;
        }, 100);
        let item = this.oldPics.find((i) => i.aidId == this.aidId);
        if (item) item.handResult = this.handData;
      }
    },
    delPic(item, index, isOld) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除图片吗？",
        onOk: () => {
          let list = isOld ? this.oldPics : this.newPics;
          if (isOld) {
            this.api2("deleteMedicalRecordScan", { aidId: item.aidId }).then(
              (res) => {
                list.splice(index, 1);
                if (!list.length) {
                  // 无图后重新拍照
                  this.photograph();
                  this.showPicList = false;
                  this.infoList = [];
                  this.isInfo = [];
                  //更新子页里的数据
                  this.$store.commit("setPicLabeling", {
                    id: this.cameraInfo3.info.registerCode,
                    value: 0,
                  });
                }
              }
            );
          } else {
            list.splice(index, 1);
          }
        },
        onCancel: () => {},
      });
    },

    async clickPic(item) {
      if (this.layer) this.layer.remove();
      this.isLogin = true;
      this.isOpen = false;
      this.isInfo = false;
      this.showPicList = true;
      this.createHander();
      this.$store.commit("clearHandData");
      this.aidId = item.aidId;

      if (/^data:/.test(item.picUrl)) {
        this.base64 = item.picUrl;
        this.imageHeight = "";
        this.imageWidth = "";
      } else {
        let url = /^http/.test(item.picUrl)
          ? item.picUrl
          : this.cloudPic + "/hand/" + item.picUrl;
        let imgdata = await this.common
          .getImgBase64(url)
          .catch((err) => console.log(err));
        if (!imgdata) {
          this.isLogin = false;
          this.$Message.error("无效图片链接，不能解读");
          if (this.layer) this.layer.remove();
          this.layer = null;
          return;
        }
        this.base64 = imgdata.base64;
        this.imageHeight = imgdata.imageHeight;
        this.imageWidth = imgdata.imageWidth;
      }

      this.api2("getHandUnscrambleByAdiId", {
        aidId: this.aidId, //	明细主键Id
        patientCode: this.cameraInfo3.info.patientCode, //	患者编码
      }).then((res) => {
        res.result.handversion = item.handversion || 1;
        // 测试
        // this.$store.commit("setHandData", omljosn);
        this.$store.commit("setHandData", res.result);
      });
    },

    // 测试
    /*
    async clickPic2(item) {
      item.picUrl =
        "https://pic.cimaizhongyi.com/Picture/other/202407/6-20240725173120585.jpg";

      if (this.layer) this.layer.remove();
      this.isOpen = false;
      this.isInfo = false;
      this.showPicList = true;
      this.createHander();
      this.$store.commit("clearHandData");
      this.aidId = item.aidId;

      let imgdata = await this.common
        .getImgBase64(item.picUrl)
        .catch((err) => console.log(err));
      if (!imgdata) {
        this.isLogin = false;
        this.$Message.error("无效图片链接，不能解读");
        if (this.layer) this.layer.remove();
        this.layer = null;
        return;
      }
      this.base64 = imgdata.base64;
      this.imageHeight = imgdata.imageHeight;
      this.imageWidth = imgdata.imageWidth;

      this.$store.commit("setHandData", omljosn);
    },
    */

    isToday(datestr) {
      if (!datestr) return false;
      return (
        this.common.parseTime(new Date(), "{y}-{m}-{d}") ==
        this.common.parseTime(new Date(datestr), "{y}-{m}-{d}")
      );
    },
    getData() {
      let obj = {
        patientCode: this.cameraInfo3.info.patientCode,
        registerCode: this.cameraInfo3.info.registerCode,
        picType: 1,
      };
      this.api2("queryMedicalRecordScan", obj).then((res) => {
        this.oldPics = res.result;
        // 有手相图片直接解读第一张
        if (this.oldPics.length) {
          this.isPic = true;
          this.clickPic(this.oldPics[this.oldPics.length - 1]);
        } else {
          this.isPic = false;
        }

        setTimeout(() => {
          this.scrollIntoView();
        }, 300);

        this.$store.commit("sendLog", {
          remarks: "获取手相历史图片 ",
          apiName: "queryMedicalRecordScan",
          inParams: obj,
          outParams: res,
        });
      });
    },

    scrollIntoView() {
      const element = document.getElementById("photograph-btn");
      if (element) {
        element.scrollIntoView();
      }
    },

    poupoPic() {
      if (!this.oldPics.length) {
        this.$Message.warning("暂无其它手相图片");
      } else {
        this.isPic = true;
        this.showPicList = true;
        this.scrollIntoView();
      }
    },
    plusCamera() {
      var cmr = window.plus.camera.getCamera();
      cmr.captureImage(
        (p) => {
          console.log("成功：" + p);
          window.plus.io.resolveLocalFileSystemURL(
            p,
            (entry) => {
              entry.file(function (file) {
                var fileReader = new plus.io.FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onloadend = function (e) {
                  this.picUrl = e.target.result.toString();
                  console.log(this.picUrl);
                };
              });
            },
            (e) => {
              console.log("读取拍照文件错误：" + e.message);
            }
          );
        },
        (e) => {
          console.log("失败：" + e.message);
        },
        { filename: "_doc/camera/", index: 1 }
      );
    },
    photograph() {
      this.reset();
      if (this.layer) this.layer.remove();
      this.layer = null;
      clearTimeout(this.djs);
      this.showPicList = false;
      this.isPic = false;
      this.isInfo = false;
      this.showZoomBtn = false;
      this.isOpen = false;
      this.$store.commit("clearHandData");
    },
    closeFun() {
      this.cancel();
    },
    cancel() {
      this.isPic = true;
      if (this.$refs.camera3) {
        this.$refs.camera3.closeCamera();
      }
      this.$store.commit("setCameraInfo3", {
        showWin: false,
        info: {},
      });
      if (this.layer) this.layer.remove();
      this.layer = null;
      this.$store.commit("clearHandData");
      this.reset();
    },

    uploadPic() {
      if (this.$refs.camera3) {
        this.$refs.camera3.handleClick();
      }
    },

    createHander() {
      if (
        [
          "Mac2",
          "Win2000",
          "WinXP",
          "Win2003",
          "WinVista",
          "Win7",
          "win8",
        ].includes(this.common.detectOS())
      ) {
        this.systemVersionTooLow = true;
      } else {
        this.systemVersionTooLow = false;
        let container = this.$el.querySelector("#container");

        this.scene = new Scene({
          container,
          mode: "stickyWidth",
        });
        if (this.layer) this.layer.remove();
        this.layer = this.scene.layer();
        this.hander = new Hander(this.layer);
        this.$store.commit("sendLog", {
          remarks: "实例化 spritejs 画布系统完成",
        });

        this.isLogin = true;
      }
    },

    init() {
      setTimeout(() => {
        Object.hasOwnProperty.call(this.handData, "texture")
          ? this.formatData2()
          : this.formatData1();
      }, 100);
    },

    // 按指定字段对对象数组分组
    groupBy(array, key) {
      return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
        return result;
      }, {});
    },

    reset() {
      this.unscrambleList = {};
      this.unscrambleColorList = {};
      this.infoList2.forEach((i) => {
        i.value = [];
        i.isShow = false;
      });
    },

    // 新版本格式化数据
    formatData2() {
      this.isLogin = false;
      this.reset();

      let obj = {
        graphical: [], //图形
        texture: [], //纹路
        speckle: [], //斑点
        ninePoint: [], //九区中点和名称
        finger: [], //手指数据
        qingjin: [], // 青筋
        version: 2, // 版本
      };

      // 整理区块名称和区块中心点坐标
      let nine = this.handData.nineHillsPlains;
      obj.ninePoint = nine
        .filter((i) => i.regionName)
        .map((i) => {
          let p = i.graphical.coordinate;
          let point = [
            p.reduce((sum, j) => {
              return (sum += j[0]);
            }, 0) / p.length,
            p.reduce((sum, j) => {
              return (sum += j[1]);
            }, 0) / p.length,
          ];
          return {
            label: i.regionName,
            point,
          };
        });

      this.setPoint2(this.handData, obj);

      obj.threeMainLine = [];
      let handLine = this.handData.handLine;

      // 三大主线
      handLine.forEach((i) => {
        let arr = i.graphical.metadata;

        // 找断点
        let indexs = [];
        arr.forEach((j, index) => {
          if (j.breakPointFlag) {
            indexs.push(index);
          }
        });
        indexs.unshift(0);
        indexs.push(arr.length - 1);
        let arr3 = this.common.chunkArray(indexs, 2); //按长度为2切割数组
        arr3.forEach((i) => {
          let list = arr.slice(i[0], i[1] + 1);
          let points = list
            .filter((j) => j.splitObjIndex == -1)
            .map((i) => i.coordinate);

          obj.threeMainLine.push({
            text: i.lineName,
            points,
          });
        });
      });

      // 分支线
      handLine.forEach((i) => {
        let list = i.graphical.metadata;
        // 1、先找到分叉点，即branchpointflg为true的
        let list2 = list.filter(
          (j) => j.branchPointFlag && j.splitObjIndex == -1
        );
        // 找到所有分叉线上的点，即splitobjindex不等于-1的
        let list3 = list.filter((j) => j.splitObjIndex != -1);
        let g = [];
        list2.filter((i) => {
          let arr = list3.filter(
            (j) => j.parentPointIndex == i.branchPointIndex
          );
          let o = this.groupBy(arr, "splitObjIndex");
          for (const key in o) {
            if (Object.hasOwnProperty.call(o, key)) {
              let l = o[key];
              // l.unshift(i)
              g.push(l);
            }
          }
        });
        g.forEach((j) => {
          let points = j.map((i) => i.coordinate);
          obj.threeMainLine.push({
            text: "",
            points,
          });
        });
      });

      // 青筋
      if (this.handData.palm) {
        this.handData.palm.qingjin.forEach((j) => {
          let str = this.formatUnscramble(j.privateUnscrambles);
          obj.qingjin.push({
            text: str ? "青筋：" + str : "青筋",
            points: j.graphical.coordinate,
          });
        });
      }

      // 添加手指数据
      this.handData.finger.forEach((i) => {
        i.jointWrinkle.forEach((j) => {
          obj.finger.push({
            text: "",
            points: j.graphical.coordinate,
            // isFinger: true, // 是指节纹
          });
        });
      });

      Object.assign(obj, {
        base64: this.base64,
        imageHeight: this.imageHeight || this.palmDeviceSize.width,
        imageWidth: this.imageWidth || this.palmDeviceSize.height,
      });

      if (this.hander) this.hander.setData(obj);
      this.showInfo = true;
      this.showZoomBtn = true;
    },

    // 旧版本格式化数据
    formatData1() {
      this.isLogin = false;

      this.infoList = [];
      let obj = {
        graphical: [], //图形
        texture: [], //纹路
        speckle: [], //斑点
        ninePoint: [], //九区中点和名称
        version: 1, // 版本
      };

      // 整理区块名称和区块中心点坐标
      let nine = this.handData.nineHillsPlains;
      // 合并手指的数据
      // nine = nine.concat(this.handData.finger)

      obj.ninePoint = nine
        .filter((i) => i.graphical)
        .map((i) => {
          let p = i.graphical.coordinate;
          let point = [
            p.reduce((sum, j) => {
              return (sum += j[0]);
            }, 0) / p.length,
            p.reduce((sum, j) => {
              return (sum += j[1]);
            }, 0) / p.length,
          ];
          return {
            label: i.regionName,
            point,
          };
        });

      this.setPoint(nine, obj);
      this.infoList = this.toRepeat(this.infoList);
      this.oldSetInfoList();

      obj.threeMainLine = this.handData.threeMainLine.map((i) => {
        return {
          text: i.lineName,
          points: i.graphical.coordinate,
        };
      });

      Object.assign(obj, {
        base64: this.base64,
        imageHeight: this.imageHeight || this.palmDeviceSize.width,
        imageWidth: this.imageWidth || this.palmDeviceSize.height,
      });

      if (this.hander) this.hander.setData(obj);
      this.showInfo = true;
      this.showZoomBtn = true;
    },

    oldSetInfoList() {
      let arr = [];
      this.infoList.forEach((i) => {
        arr.push(i.label);
        arr.push(i.values);
      });
      let item = this.infoList2.find((i) => i.id == 1);
      item.value = [arr.join("<br/>")];
      item.isShow = true;
      item.value.push({
        text: [
          `<span class="mk-title"><span>掌型:${this.handData.palmName}</span></span>`,
          this.handData.unscramble.replace(/\s*\r\n\s*/g, "</br>"),
        ].join("</br>"),
        showMore: false,
      });
    },

    // 调OML接口
    async getOMLapi(imageInfo) {
      this.base64 = imageInfo.base64;
      let picUrl = /^http/.test(imageInfo.picUrl)
        ? imageInfo.picUrl
        : config.intranetPic + imageInfo.picUrl;
      let params = {
        params: {
          picId: imageInfo.aidId,
          apiUrl: config.omlToCimaiApi,
          picUrl,
          userdata: {
            picUrl,
            picId: imageInfo.aidId,
            patientCode: this.cameraInfo3.info.patientCode,
            sex: this.cameraInfo3.info.sex == "男" ? 1 : 2, // 1：男 2：女
            socketClientId: this.userInfo.socketClientId,
          },
        },
      };

      // 保存图片id信息 用于等待获取解析数据用
      this.$store.commit("saveHandPicData", {
        picId: imageInfo.aidId,
        sex: this.cameraInfo3.info.sex == "男" ? 1 : 2, // 1：男 2：女
      });

      let fun = "uploadPictureToOML";
      this.api2(fun, params)
        .then((res) => {
          setTimeout(() => {
            this.$store.commit("sendLog", {
              remarks: "OML接口调用",
              apiName: "uploadPictureToOML",
              outParams: res,
            });
          }, 1000);

          // 检测手机解析数据是否有传过来
          this.$store.commit("OMLSuccess", imageInfo.aidId);
          //测试 实际是用socket消息调用此方法
          // this.$store.commit("setHandData");
        })
        .catch((err) => {
          this.photograph();
        });
    },

    // 保存病历扫描图片信息
    async showPic(imageInfo) {
      this.imageHeight = imageInfo.imageHeight;
      this.imageWidth = imageInfo.imageWidth;

      this.isPic = true;

      if (imageInfo.debug) {
        this.createHander();
        this.base64 = imageInfo.base64;
        return;
      }

      this.aidId = imageInfo.aidId;
      this.oldPics.push({
        aidId: this.aidId,
        picUrl: imageInfo.base64,
        crDt: this.common.parseTime(new Date(), "{y}-{m}-{d} {h}:{i}"),
      });

      this.getOMLapi({
        aidId: this.aidId,
        base64: imageInfo.base64,
        picUrl: imageInfo.picUrl,
      });

      this.createHander();
    },

    showNiceFun() {
      this.showNice = !this.showNice;
      this.hander.setNiceTipVisibility(this.showNice ? 1 : 0);
    },

    zoom(isEnlarge) {
      let pos = {
        x: this.layer.width / 2,
        y: this.layer.height / 2,
      };
      this.hander.zoom(pos, isEnlarge);
    },

    // nb 置信度  isRed 是否红色
    round(nb, isRed) {
      return nb && nb >= this.confidenceProportion
        ? isRed
          ? `<i>(${Math.round(nb * 100)}%)</i>`
          : `(${Math.round(nb * 100)}%)`
        : "";
    },
    // 把内容里的 "1、2、"换成 "①②", isClearGroupTag 是否清除分组标签
    formatSerialNumber(str, isClearGroupTag = false) {
      let m = str.match(/\[\w+\d+\]/gi); //把分组号提取出来
      if (m) str = str.replace(m[0], "");
      str = str.replace(/\[(\p{sc=Han}+)\]/gu, ""); //去除[身体系统名称]
      str =
        str && /\d+[、]/.test(str)
          ? str
              .split(/\d+[、]/gi)
              .filter((item) => item)
              .map((item, index) => this.xh[index] + item)
              .join(" ")
          : str;
      str = this.addRareText(str);
      return isClearGroupTag ? str : m ? m + str : str;
    },

    addRareText(str) {
      this.handRareData.forEach((item) => {
        if (
          str.replace(/[。，、\n\t]/g, "") ==
          item.label.replace(/[。，、\n\t]/g, "")
        ) {
          str = `<div class="rare-text">
            <span class="r-t-label">稀有(${item.string2}%)<i>此词条在全体用户中仅占约${item.string2}%</i></span>
            <span><i class="xszy-icon icon-xingxing"></i>${item.label}<i class="xszy-icon icon-xingxing"></i></span>
          </div>`;
        }
      });
      return str;
    },

    setUnscrambleStr(i) {
      i.unscrambleStr = this.addRed(
        this.formatSerialNumber(i.unscramble) + this.round(i.confidence, true),
        i.confidence
      );
      return i;
    },

    // isOtherPalmUnscrambles 是否其它掌形数据
    setUnscrambleList(list, isOtherPalmUnscrambles) {
      if (!list) return;
      list.forEach((i) => {
        if (i.unscrambleResource != 1) {
          this.setUnscrambleListFun(i, isOtherPalmUnscrambles);
        } else {
          let arr = i.unscramble.split(/\d+、/).filter((item) => item);
          let objList = arr.map((j) => {
            let o = this.common.clone(i);
            o.unscramble = j;
            o.weight = o.confidence / arr.length;
            return o;
          });
          objList.forEach((j) => {
            this.setUnscrambleListFun(j, isOtherPalmUnscrambles);
          });
        }
      });
    },

    // 删除[***]然后比较是否重复
    removeGroupNameStr(str) {
      return str.replace(/\[.*?\]/g, "").trim();
    },

    setUnscrambleListFun(i, isOtherPalmUnscrambles) {
      let arr = this.unscrambleList[i.unscrambleResource];
      let confidence =
        i.confidence && i.confidence.length ? i.confidence[0] : 0;
      let obj = {
        unscramble: i.unscramble,
        unscrambleType: i.unscrambleType,
        unscrambleStr: "",
        confidence,
        weight: i.weight || confidence, // 权重后续用于排序
      };
      if (i.unscrambleResource != 1 || i.unscrambleType == 4) {
        obj.unscramble = obj.unscramble.replace(/\[(\p{sc=Han}+)\]/gu, ""); //去除[身体系统名称]
        this.setUnscrambleStr(obj);
      }
      if (i.unscrambleType == 4) {
        let findIndex = this.colorList.findIndex(
          (item) =>
            this.removeGroupNameStr(item.unscramble) ==
            this.removeGroupNameStr(obj.unscramble)
        );
        if (findIndex != -1) {
          let item = this.colorList[findIndex];
          if (item.confidence < obj.confidence) {
            this.colorList[findIndex] = obj;
          }
        } else {
          this.colorList.push(obj);
        }
      } else {
        // 如果是掌形其它数据 在arr没值的情况下才添加
        if (!(isOtherPalmUnscrambles && arr && arr.length)) {
          if (arr) {
            // 查找是否已经存在 如果存在则更新为最高的置信度
            let findIndex = arr.findIndex(
              (item) =>
                this.removeGroupNameStr(item.unscramble) ==
                this.removeGroupNameStr(obj.unscramble)
            );
            if (findIndex != -1) {
              let item = arr[findIndex];
              if (item.confidence < obj.confidence) {
                item.confidence = obj.confidence; // 更新置信度
              }
              item.weight += obj.weight; // 累加权重
            } else {
              arr.push(obj);
            }
          } else {
            this.unscrambleList[i.unscrambleResource] = [obj];
          }
        }
      }
    },

    formatUnscramble(list) {
      if (!list) return "";
      let arr = [];
      list.forEach((i, index) => {
        let confidence =
          i.confidence && i.confidence.length
            ? this.round(i.confidence[0])
            : "";
        arr.push(
          `${index + 1}、${this.formatSerialNumber(
            i.unscramble,
            true
          )}${confidence}`
        );
      });
      return arr.join(" ");
    },

    // 高亮显视(加红)
    addRed(str, confidence) {
      return `<span class="${
        confidence >= this.confidenceProportionRed ? "red" : ""
      }">${str}</span>`;
    },

    // 合并同置信度的数据
    mergeData(list) {
      let groupList = [];
      list.forEach((i) => {
        let item = groupList.find((j) => j.confidence == i.confidence);
        if (item) {
          item.list.push(i);
        } else {
          groupList.push({
            list: [i],
            confidence: i.confidence,
          });
        }
      });
      groupList.forEach((i) => {
        let str =
          i.list
            .map(
              (j, index) =>
                `${i.list.length > 1 ? this.xh[index] : ""}${this.addRareText(
                  j.unscramble
                )}`
            )
            .join("") + this.round(i.confidence, true);
        i.unscrambleStr = this.addRed(str, i.confidence);
      });
      return groupList;
    },

    // 按身体系统分组
    formatBodyGroup(list) {
      let newList = [];
      list.forEach((i) => {
        let strs = /\[(\p{sc=Han}+)\]/gu.exec(i.unscramble);
        let key = strs ? strs[1] : "其他";
        if (strs) i.unscramble = i.unscramble.replace(strs[0], "");
        let arr = [];
        let item = newList.find((item) => item.name == key);
        if (item) {
          item.list.push(i);
        } else {
          newList.push({ name: key, list: [i] });
        }
      });

      newList.forEach((item) => {
        let weight = 0;
        item.list.forEach((i) => {
          this.setUnscrambleStr(i);
          weight += i.weight;
        });
        item.weight = item.name == "其他" ? 0 : weight; //其他不计算权重 后面排序用
        item.list = this.formatGroup(item.list, 1); //删除冲突分组
        item.list = this.mergeData(item.list); //合并同置信度的数据
        this.sortList(item.list);
      });

      // 按权重排序 但名为”其它“的组排在最后
      newList.sort((a, b) => {
        return b.weight - a.weight;
      });

      let newList2 = [];
      newList.forEach((o) => {
        this.addSerialNumber(o.list); //添加序号
        newList2.push(...this.moreGroup(o.list, o.name));
      });
      return newList2;
    },

    // 取出置信度最高于0.66的默认显示 ,其他显示更多里, 如果没有低的则不显高更多按钮, 如果没有高于0.66的而取一条低的默认显视，其它放更多里。
    moreGroup(list, key) {
      let showList = [];
      let moreList = [];
      list.forEach((i) => {
        if (i.confidence >= this.confidenceProportionRed || /稀有\(/.test(i.unscrambleStr)) {
          showList.push(i);
        } else {
          moreList.push(i);
        }
      });
      if (!showList.length) {
        showList.push(moreList.shift());
      }
      let title = key
        ? `<span class="mk-title"><span>${key}</span></span></br>`
        : "";
      let isShowMore = {
        value: false,
      };
      let showItemList = [
        {
          text: showList
            .map((j, index) => (!index ? title : "") + j.unscrambleStr)
            .join("</br>"),
          showMore: false,
          isShowMore,
          onShowMore: moreList.length
            ? (state) => {
                if (state === undefined) {
                  isShowMore.value = !isShowMore.value;
                } else {
                  isShowMore.value = state;
                }
              }
            : null,
        },
      ];
      if (moreList.length) {
        showItemList.push({
          text: moreList.map((j) => j.unscrambleStr).join("</br>"),
          showMore: true,
          isShowMore,
        });
      }
      return showItemList;
    },

    // 删除冲突分组如 [A1]和[A2]是冲突组取数据条数多的 如果一样多则取A1。
    formatGroup(list, type) {
      let newList = [];
      let groupList = {};
      list.forEach((i) => {
        let strs = /(\[(\w)(\d)\])/.exec(i.unscrambleStr);
        if (strs) {
          let obj = groupList[strs[2]] || {};
          let arr = obj[strs[3]] || [];
          i.unscramble = i.unscramble.replace(strs[0], "");
          i.unscrambleStr = i.unscrambleStr.replace(strs[0], "");
          arr.push(i);
          obj[strs[3]] = arr;
          groupList[strs[2]] = obj;
        } else {
          newList.push(i);
        }
      });

      for (const key in groupList) {
        let list = [];
        if (Object.hasOwnProperty.call(groupList, key)) {
          const i = groupList[key];
          if (i[1] && i[2]) {
            if (type == 1) {
              //如果是健康类里 则取置信度高的
              let confidence1 = i[1].reduce((num, next) => {
                return next.confidence < num ? num : next.confidence;
              }, 0);
              let confidence2 = i[2].reduce((num, next) => {
                return next.confidence < num ? num : next.confidence;
              }, 0);
              list = confidence1 >= confidence2 ? i[1] : i[2];
            } else {
              list = i[1].length >= i[2].length ? i[1] : i[2];
            }
          } else {
            list = i[1] || i[2];
          }
        }
        newList.push(...list);
      }
      return newList;
    },

    // 按置信度排序
    sortList(list) {
      list.sort((a, b) => b.confidence - a.confidence);
      return list;
    },

    // 添加序号
    addSerialNumber(list) {
      list.forEach((i, index) => {
        i.unscrambleStr = i.unscrambleStr.replace(">", `>${index + 1}、`);
      });
    },

    setInfoList() {
      for (const key in this.unscrambleList) {
        if (Object.hasOwnProperty.call(this.unscrambleList, key)) {
          if (key == 1) {
            let list = this.formatBodyGroup(this.unscrambleList[key], key);
            let item = this.infoList2.find((i) => i.id == 1);
            item.value = list;
          } else {
            const i = this.formatGroup(this.unscrambleList[key], key);
            // 排序
            this.unscrambleList[key] = this.sortList(i);
          }
        }
      }

      this.infoList2.forEach((i) => {
        if (this.unscrambleList[i.id]) {
          if (i.id != 1) {
            let list = this.unscrambleList[i.id];
            this.addSerialNumber(list);
            i.value = this.moreGroup(list);
          }
          i.isShow = true;
        } else {
          i.isShow = false;
        }
      });
    },

    // 新版数据整理方法
    setPoint2(handData, obj) {
      this.colorList = [];

      // 收集解读信息
      this.setUnscrambleList(handData.jointWrinkleUnscrambles);

      this.setUnscrambleList(handData.mixUnscrambles);

      handData.handLine.forEach((i) => {
        this.setUnscrambleList(i.unscrambles);
      });

      handData.finger.forEach((i) => {
        this.setUnscrambleList(i.unscrambles);
      });

      handData.nineHillsPlains.forEach((i) => {
        this.setUnscrambleList(i.unscrambles);
        if (i.graphical && i.regionCode != "ALL") {
          obj.graphical.push({
            text: i.regionName || "",
            points: i.graphical.coordinate,
          });

          // 收集纹解读数据
          let item = handData.texture.find((j) =>
            j.nineHillsRegion.includes(i.regionCode)
          );
          if (item) {
            item.regionList = item.regionList || [];
            item.regionList.push({
              regionName: i.regionName,
              textureUnscrambles: i.textureUnscrambles,
            });
          }
        }
      });

      // 掌形其它解读
      this.setUnscrambleList(handData.otherPalmUnscrambles, true);

      this.setInfoList();
      let item = this.infoList2.find((i) => i.id == 1);
      let isShowMore = {
        value: false,
      };
      if (handData.palmColorUnscramble) {
        item.value.push({
          text: [
            `<span class="mk-title"><span>掌型颜色解读</span></span>`,
            `<span class="red">${handData.palmColorUnscramble.replace(
              /\s*\r*\n\s*/g,
              "</>"
            )}<span>`,
          ].join("</br>"),
          showMore: false,
          isShowMore,
          onShowMore: this.colorList.length
            ? (state) => {
                if (state === undefined) {
                  isShowMore.value = !isShowMore.value;
                } else {
                  isShowMore.value = state;
                }
              }
            : null,
        });
      }
      if (this.colorList.length) {
        this.colorList = this.formatGroup(this.colorList); //删除冲突分组
        item.value.push({
          text: this.colorList
            .map((i, index) => index + 1 + "、" + i.unscrambleStr)
            .join("</br>"),
          showMore: true,
          isShowMore,
        });
      }
      if (handData.palmUnscramble) {
        item.value.push({
          text: [
            `<span class="mk-title"><span>掌型:${handData.palmName}</span></span>`,
            handData.palmUnscramble.replace(/\s*\r\n\s*/g, "</br>"),
          ].join("</br>"),
          showMore: false,
        });
      }

      // 纹
      handData.texture.forEach((j) => {
        let str = this.formatUnscramble(j.privateUnscrambles);
        let p = j.graphical.coordinate;
        obj.texture.push({
          text: j.textureName + ": " + str,
          points: [p[0], p[2]],
        });
      });

      // 斑点
      handData.speckle.forEach((j) => {
        let str = this.formatUnscramble(j.privateUnscrambles);
        let p = j.graphical.coordinate;
        obj.speckle.push({
          text: (j.unscramble || j.speckleName) + "：" + str,
          // 获取斑点中心点
          points: [
            p[0][0] + (p[1][0] - p[0][0]) / 2,
            p[0][1] + (p[2][1] - p[1][1]) / 2,
          ],
        });
      });
    },

    // 旧版数据整理方法
    setPoint(list, obj) {
      list.forEach((i) => {
        if (i.graphical) {
          obj.graphical.push({
            text: i.regionName || "",
            points: i.graphical.coordinate,
          });
        }

        // 纹
        if (i.texture) {
          i.texture.forEach((j) => {
            if (
              j.graphical.confidence &&
              j.graphical.confidence[0] >= this.confidenceProportion
            ) {
              let confidence = this.round(j.graphical.confidence[0]);
              if (j.unscramble) {
                this.infoList.push({
                  label: i.regionName,
                  value: j.unscramble + " " + confidence, //显视置信度数组
                  values: [],
                });
              }
              obj.texture.push({
                text: (j.unscramble || j.textureName) + " " + confidence,
                points: j.graphical.coordinate,
              });
            }
          });
        }

        // 斑点
        if (i.speckle) {
          i.speckle.forEach((j) => {
            if (j.unscramble) {
              this.infoList.push({
                label: i.regionName,
                value: j.unscramble,
                values: [],
              });
            }

            let p = j.graphical.coordinate;
            obj.speckle.push({
              text: j.unscramble || j.speckleName,
              // 获取斑点中心点
              points: [
                p[0][0] + (p[1][0] - p[0][0]) / 2,
                p[0][1] + (p[1][1] - p[0][1]) / 2,
              ],
            });
          });
        }

        if (i.subRegion && i.subRegion.length) {
          this.setPoint(i.subRegion, obj);
        }
      });
    },
    toRepeat(list) {
      let newList = [];
      list.forEach((i) => {
        let item = newList.find((j) => j.label == i.label);
        let value = i.value.replace(/^\d+、*/, "");
        if (item) {
          if (!item.values.find((x) => x == i.value) && i.value)
            item.values.push(value);
        } else {
          newList.push({
            label: i.label,
            values: [value],
          });
        }
      });

      newList.forEach((i) => {
        i.values = i.values
          .map((j, index) => {
            return (i.values[index] = `${index + 1}、${j}`);
          })
          .join("<br/>");
      });
      return newList;
    },
    setHeight() {
      this.height = document.documentElement.clientHeight - 120;
    },
    handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("Element is visible");
        } else {
          console.log("Element is not visible");
        }
      });
    },
  },
  mounted() {
    this.setHeight();
  },
};
</script>

<style>
@import url("./camera3.css");
</style>
<style lang="scss">
.hand2_con {
  .ivu-modal-mask {
    background: none;
  }
  .ivu-modal-wrap {
    top: 50px;
  }
  .h-body {
    background: #f5f5f5;
    display: flex;
    height: 100%;
    &.hide {
      visibility: hidden;
    }
    .h-left {
      width: 150px;
      height: 100%;
      background: #fff;
      box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      .h-menu {
        height: 100%;
        user-select: none;
        .h-menu-item {
          padding: 15px;
          text-align: center;
          cursor: pointer;
          &.active {
            background: #fbf7f5;
            color: #843a2f;
            position: relative;
            font-weight: bold;
            &::after {
              content: "";
              display: block;
              width: 3px;
              height: 30px;
              background: #843a2f;
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              border-radius: 5px;
            }
          }
        }
      }
      .h-title {
        font-weight: bold;
        font-size: 16px;
        padding: 20px 10px 10px;
        color: #333;
        .iconfont {
          padding: 0 10px 0 20px;
          color: #843a2f;
          font-size: 20px;
        }
      }
      .h-button-group {
        margin: 10px;
        background: #fbf9f8;
        padding: 15px;
        user-select: none;
        .h-button-title {
          border-bottom: 1px solid #eee;
          margin-bottom: 5px;
          padding-bottom: 8px;
          font-weight: bold;
          text-align: center;
          color: #333;
        }
        .h-button-list {
          .ivu-checkbox {
            display: none;
          }
          .ivu-checkbox-group-item {
            padding: 5px 0;
            .iconfont {
              padding-right: 5px;
            }
            .icon2 {
              display: none;
            }
            &.ivu-checkbox-wrapper-checked {
              color: #843a2f;
              font-weight: bold;
              .icon2 {
                display: inline-block;
              }
              .icon1 {
                display: none;
              }
            }
          }
        }
      }
    }
    .h-center {
      flex: 1;
      padding: 15px 0 15px 15px;
      height: 100%;
    }
    .h-center-body {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .h-center-content {
      position: relative;
      height: 100%;
    }

    .info-list {
      height: 100%;
      width: 100%;
      overflow-y: auto;
      position: absolute;
      z-index: 10;
      // inset: 0;
    }
    .mk {
      padding: 15px;
      border: 1px solid #ede3e1;
      border-radius: 6px;
      margin-bottom: 15px;
      line-height: 2rem;
      &.active {
        background: #ede3e1;
      }
      .mk-title {
        font-weight: bold;
        columns: #222;
        font-size: 16px;
        .icon {
          padding-right: 10px;
          color: #843a2f;
          font-size: 18px;
        }
      }
      .mk-body-item {
        .mk-title {
          font-size: 15px;
        }
      }
    }
    .h-right {
      flex: 1;
      padding: 15px;
    }
    .h-right-body,
    .info-list {
      height: 100%;
      padding: 15px;
    }
    .h-right-body {
      display: flex;
      flex-direction: column;
      .info-list {
        padding: 0;
      }
    }
    .h-right-body,
    .h-center-body {
      background: #fff;
      box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
    }

    .h-right-hender {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
    }
    .h-right-content {
      flex: 1;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 15px;
      .icon {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 0 10px;
        background: #f4f4f4;
        &:hover,
        &.actice {
          background: #843a2f;
          color: #fff;
        }
        i {
          font-size: 20px;
        }
      }
    }
  }
  .userinfo2 {
    .icon {
      color: #843a2f;
      padding-right: 10px;
      font-size: 20px;
    }
    span {
      padding-right: 10px;
    }
    .name {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .modal_close {
    right: 20px;
    top: 20px;
  }
  .mk-body {
    .mk-body-item {
      position: relative;
      &.isMore {
        height: 0px;
        overflow: hidden;
      }
      &.isMore.showMore {
        height: auto;
        overflow: visible;
      }
    }
    .more-btn2 {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      opacity: 0.5;
      cursor: pointer;
    }
    .more-btn {
      text-align: center;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 5px 0 5px;
      line-height: 20px;
      background: #fff;
    }
  }
  .active {
    .mk-body {
      .more-btn {
        background: #ede3e1ff;
      }
    }
  }
  .red {
    color: #515a6e;
    i {
      color: #f00;
    }
  }
  .h-right-content .mk,
  .mk + .mk {
    .more-btn2 {
      top: -35px;
    }
  }
  .h-right {
    .h-right-hender {
      padding-top: 0;
    }
    .show-palmistry-btn {
      display: flex;
      align-items: center;
      margin-right: 30px;
      margin-top: -3px;
      .ivu-switch {
        margin-left: 5px;
      }
    }
  }
  .hide-palmistry {
    visibility: hidden;
  }
  .btn1 {
    margin-right: 15px;
    cursor: pointer;
    icon {
      font-size: 14px;
      width: 16px;
      height: 16px;
      display: inline-block;
    }
  }

  .rare-text {
    display: inline;
    color: #2e74ec;
    .xszy-icon {
      color: #2e74ec;
    }
    .r-t-label {
      background: #dfe8f6;
      padding: 0 5px;
      border-radius: 10px;
      margin-right: 4px;
      position: relative;
      cursor: pointer;
      &:hover {
        i {
          display: inline-block;
        }
      }
      i {
        color: #515a6e !important;
        display: none;
        white-space: nowrap;
        font-style: normal;
        color: #666;
        font-size: 13px;
        padding: 5px 10px;
        position: absolute;
        left: 0;
        top: -40px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #fff;
      }
    }
  }
  .desc {
    text-align: right;
    font-size: 13px;
    margin-bottom: 5px;
    i {
      color: #2e74ec;
      background: #dfe8f6;
      padding: 0 5px;
      border-radius: 10px;
      margin-right: 4px;
      cursor: pointer;
      font-style: normal;
    }
  }
}
</style>
